<div class="region-dictionary-select">
  <span>{{ label() | translate }}</span>
  <msf-tree-select
    [model]="pendingId()"
    (modelChange)="onPendingChange($event)"
    [options]="regions()"
    [placeholder]="'Select Region' | translate"
    [showClear]="true"
    appendTo="body"
  ></msf-tree-select>
  @if (selectedRegions().length) {
    <ul class="region-dictionary-select__chips">
      @for (region of selectedRegions(); track region.id) {
        <li>
          <span>{{ region.label }}</span>
          <button
            type="button"
            class="region-dictionary-select__remove"
            (click)="removeRegion(region.id)"
            [attr.aria-label]="'Clear' | translate"
          >×</button>
        </li>
      }
    </ul>
  }
</div>
